<template>
  <div class='supplier-water' v-loading='importLoading'>
    <div class='nav'>
      <el-form :model='form' label-width='85px' :inline='true' class='demo-form-inline flex1'>
        <el-form-item label='供应商:'>
          <el-input v-model='form.supplierName' size='mini' placeholder='请输入供应商'></el-input>
        </el-form-item>
        <el-form-item label='批次号:'>
          <el-input v-model='form.batchNumber' size='mini' placeholder='请输入批次号'></el-input>
        </el-form-item>
        <el-form-item label='运单编号:'>
          <el-input v-model='form.waybillNo' size='mini' placeholder='请输入运单编号'></el-input>
        </el-form-item>
        <el-form-item label='台账月:'>
          <el-input v-model='form.standingBookMonth' size='mini' placeholder='请输入台账月'></el-input>
        </el-form-item>
        <el-form-item label='品牌:'>
          <el-input v-model='form.brandName' size='mini' placeholder='请输入品牌名称'></el-input>
        </el-form-item>
        <el-form-item label='船舶名称:'>
          <el-input v-model='form.personnelName' size='mini' placeholder='请输入船舶名称'></el-input>
        </el-form-item>
        <el-form-item label='航次：'>
          <el-input v-model='form.voyageNumber' size='mini' placeholder='请输入航次'></el-input>
        </el-form-item>
        <el-form-item label='起始港口：'>
          <el-input v-model='form.startPortName' size='mini' placeholder='请输入起始港口'></el-input>
        </el-form-item>
        <el-form-item label='交车港口：'>
          <el-input v-model='form.deliveryPortName' size='mini' placeholder='请输入交车港口'></el-input>
        </el-form-item>
        <el-form-item label='计划日期:'>
          <el-date-picker v-model='form.planStartDate' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='开始日期' />
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='form.planEndDate' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='结束日期' />
        </el-form-item>
        <el-form-item label='是否生成对账单:' label-width='130px'>
          <el-select v-model='form.isReconciliation' filterable size='mini'
                     placeholder='请选择是否生成对账单'>
            <el-option label='全部' value=''></el-option>
            <el-option label='是' value='1'></el-option>
            <el-option label='否' value='0'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
          <el-button size='small' type='primary' @click='addBtn'>生成对账单</el-button>
          <el-button size='small' type='primary' @click='addResetBtn'>刷新结算</el-button>
<!--          <el-button size='small' type='primary' @click='ledgerRevise'>修改台账月</el-button>-->
        </el-form-item>

      </el-form>
    </div>
    <el-row>
      <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
        <span @click='download' class='pointer'>模板下载</span>
        <span style='cursor: pointer;display: inline-block;'>
        <import-statement @getList='_supplierLinePageList()'
                          @changeImportLoading='changeImportLoading' :type='11' />
        </span>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <div class='tableContainer'>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          tooltip-effect='dark'
          ref='multipleTable'
          @select='handleCurrentChange'
          @select-all='handleCurrentChange'
          :reserve-selection='true'
          :row-key='(row)=>{return row.id}'
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{height:'42px',}"
        >
          <el-table-column type='selection' align='center' width='50px'
                           :selectable='(row)=>{return row.isReconciliation !== 1}' />
          <el-table-column prop='supplierName' label='供应商' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='batchNumber' label='批次号' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='waybillNo' label='运单编号' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='personnelName' label='船名' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='voyageNumber' label='航次' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='startPortName' label='起始地' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='deliveryPortName' label='目的地' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='standingBookMonth' label='台账月' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='brandName' label='品牌' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='modelName' label='型号' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='dispatchDate' label='发运日期' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.dispatchDate|tableValueFormat('dispatchDate') }}
            </template>
          </el-table-column>
          <el-table-column prop='deliveryDate' label='交车日期' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.deliveryDate|tableValueFormat('deliveryDate') }}
            </template>
          </el-table-column>
          <el-table-column prop='carNumber' label='数量' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='taxRate' label='税率(%)' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='taxContractPrice' label='含税合同价' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='taxPreparePrice' label='含税预结算价' width='160px' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='isReconciliation' label='生成对账单' width='160px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.isReconciliation|tableValueFormat('isReconciliation') }}
            </template>
          </el-table-column>
          <el-table-column prop='actNo' label='对账单编号' width='160px' align='center'
                           show-overflow-tooltip/>
          <el-table-column prop='title' label='对账单标题' width='180px' align='center'
                           show-overflow-tooltip>
            <template slot-scope='scope'>
              {{ scope.row.title ? scope.row.title : '--' }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='form.page'
          :page-size='form.rows'
        />
      </div>
    </div>
    <el-dialog :title="importShow ? '导入生成对账单' : '生成对账单'" :visible.sync='addFlag' width='950px'
               center @close='dialogClose'>
      <water-resources-car-account
        :check-table-data='JSON.parse(JSON.stringify(checkTableDataProps))'
        :importShow='importShow'
        :settlement='settlement'
        @selectionTable='selectChange' ref='waterResourcesCarAccount'>
        <template slot='label'>基础信息</template>
        <template slot='label2'>运单费用</template>
        <template slot='label3'>其他费用</template>
      </water-resources-car-account>
    </el-dialog>
    <!-- 修改台账月 -->
    <el-dialog title='修改台账月' :visible.sync='ledgerVisible' width='750px' center
               @close='ledgerClose'>
      <div class='ledger'>
        <div class='leader-input'>
          <span>请输入台账月：</span>
          <el-input style='display:inline-block' size='small' type='text' v-model='ledger' />
          <div style='display:inline-block;width:calc(100% - 300px);text-align:right'>
            <el-button size='small' class='searchBtn' @click='ledgerChange'>确 定</el-button>
            <el-button size='small' class='resetBtn' @click='ledgerClose'>取 消</el-button>
          </div>
        </div>
        <el-table
          v-loading='ledgerLoad'
          :data='ledgerData'
          style='width: 100%'
          border
          :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
        >
          <el-table-column prop='batchNumber' label='批次号' min-width='150' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='waybillNo' label='运单号' min-width='150' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='frameNumber' label='车架号' min-width='150' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='brandName' label='品牌' min-width='100' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='modelName' label='型号' min-width='100' align='center'
                           show-overflow-tooltip />
          <el-table-column prop='startPortName' label='起始地' width='160' show-overflow-tooltip
                           align='center' />
          <el-table-column prop='deliveryPortName' label='交车地' width='160' show-overflow-tooltip
                           align='center' />
          <el-table-column prop='standingBookMonth' label='台账月' min-width='100' align='center'
                           show-overflow-tooltip />
          <el-table-column label='操作' width='60px' align='center'>
            <template slot-scope='scope'>
              <i class='el-icon-error' style='font-size: 20px;'
                 @click='delLedger(scope.$index)'></i>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getResourceVehiclePageList,
    refreshSupplierResourcesCar,
    updateStandingBookMonth,
  } from '@/service/getData';
  import { formatDateTime, getSessionStore } from '@/config/mUtils';
  import waterResourcesCarAccount from './waterResourcesCarAccount';
  import { baseUrl } from '@/config/env';
  import ImportStatement from '@/views/settle/entrust/components/import-statement';

  export default {
    components: {
      ImportStatement,
      waterResourcesCarAccount,
    },
    data() {
      return {
        form: {
          supplierName: '', // 供应商
          batchNumber: '', // 批次号
          waybillNo: '', // 运单编号
          frame: '', // 车架号
          brandName: '', // 品牌
          personnelName: '', // 船舶名称
          voyageNumber: '', // 航次
          startPortName: '', // 起始港口
          deliveryPortName: '', // 交车港口
          standingBookMonth: '', // 台账月
          planStartDate: '',
          planEndDate: '',
          isReconciliation: '', // 是否生成账单
          page: 1,
          rows: 10,
        },
        total: 0,
        tableLoad: false,
        TableDatas: [],
        checkList: [], // 导入生成账单 选择数据
        billTitle: '',
        checkLoad: false,
        checkTableDataProps: [],
        visible: false, // 导入生成账单 显示
        importShow: false,

        addFlag: false,
        name: '',
        rules: {
          plan: {
            required: true,
            message: ' ',
            trigger: 'blur',
          },
          name: [
            {
              required: true,
              message: '请输入业务名称',
              trigger: 'blur',
            },
            {
              min: 3,
              max: 9,
              message: '长度在 3 到 9 个字符',
              trigger: 'blur',
            },
          ],
          content: {
            required: true,
            message: '请输入评审需求',
            trigger: 'blur',
          },
          type: {
            required: true,
            message: '请选择评审类型',
            trigger: 'blur',
          },
          img: {
            required: true,
            message: '请选择合同照片',
            trigger: 'blur',
          },

        },
        settlement: '', // 生成对账单时的结算方式
        // 修改台账月
        ledgerVisible: false,
        ledgerLoad: false,
        ledger: '',
        ledgerData: [],
        importLoading: false,
      };
    },
    filters: {
      tableValueFormat(val, rowName) {
        if (rowName === 'isReconciliation') {
          switch (parseInt(val)) {
            case 0:
              return '否';
            case 1:
              return '是';
            case 2:
              return '部分生成';
          }
        } else if (rowName === 'dispatchDate' || rowName === 'deliveryDate') {
          return val ? formatDateTime(val, 'yyyy-mm-dd') : '';
        } else {
          return val;
        }
      },
    },
    mounted() {
     // this._supplierLinePageList();
    },
    methods: {
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/settlement/supplierLine/exportResourcesCarXls?access_token=${token}&supplierName=${this.form.supplierName}&batchNumber=${this.form.batchNumber}&waybillNo=${this.form.waybillNo}&brandName=${this.form.brandName}&personnelName=${this.form.personnelName}&voyageNumber=${this.form.voyageNumber}&startPortName=${this.form.startPortName}&deliveryPortName=${this.form.deliveryPortName}&standingBookMonth=${this.form.standingBookMonth}&planStartDate=${this.form.planStartDate}&planEndDate=${this.form.planEndDate}&isReconciliation=${this.form.isReconciliation}`;
      },
      // 分页查询
      async _supplierLinePageList() {
        this.tableLoad = true;
        const {
          status,
          message,
          data,
        } = await getResourceVehiclePageList(this.form);
        this.tableLoad = false;
        if (status !== 0) return this.$message.error(message);
        this.TableDatas = data.records;
        this.total = data.total;
      },
      // 生成对账单按钮
      addBtn() {
        if (this.checkTableDataProps.length <= 0) return this.$message.warning('请至少选择一条结算数据！');

        let supplierFlag = false; // 供应商
        let taxFlag = false; // 税率
        let reconciliationFlag = false; // 是否生成对账单
        if (this.checkTableDataProps.length > 0) {
          const {
            supplierId,
            taxRate,
          } = this.checkTableDataProps[0];
          this.checkTableDataProps.forEach((item) => {
            if (item.supplierId !== supplierId) {
              supplierFlag = true;
            }
            if (item.taxRate !== taxRate) {
              taxFlag = true;
            }
            if (item.isReconciliation) {
              reconciliationFlag = true;
            }
          });
        }
        if (supplierFlag) return this.$message.warning('只能选择同一家供应商数据！');
        if (taxFlag) return this.$message.warning('部分数据税率不相等！');
        if (reconciliationFlag) return this.$message.warning('部分数据已生成对账单！');

        this.$confirm('请选择结算方式', '提示', {
          confirmButtonText: '合同价',
          cancelButtonText: '预结算',
          distinguishCancelAndClose: true,
          type: 'warning',
        })
          .then(() => {
            let type = false;
            this.checkTableDataProps.forEach((item) => {
              if (!item.taxContractPrice || item.taxContractPrice == '' || !item.contractPrice || item.contractPrice == '') {
                return type = true;
              }
            });
            if (type) {
              this.$message.warning('操作失败，部分数据未拥有合同价！');
              return;
            }
            this.settlement = 1;
            // 生成对账单弹窗显示
            this.addFlag = true;
            this.$nextTick(() => {
              this.$refs.waterResourcesCarAccount.init(this.checkTableDataProps, 11);
            });
            // 判断是否是导入生成对账单
            this.importShow = false;
          })
          .catch((action) => {
            if (action == 'close') return false;
            let type = false;
            let state = false;
            this.checkTableDataProps.forEach((item) => {
              if (item.taxContractPrice && item.taxContractPrice != '' && item.contractPrice && item.contractPrice != '') {
                return type = true;
              }
            });
            if (type) return this.$message.warning('部分数据只能使用合同价！');
            this.checkTableDataProps.forEach((item) => {
              if (!item.taxPreparePrice || item.taxPreparePrice == '' || !item.preparePrice || item.preparePrice == '') {
                return state = true;
              }
            });
            if (state) return this.$message.warning('操作失败，部分数据未拥有预结算价！');
            this.settlement = 2;
            // 生成对账单弹窗显示
            this.addFlag = true;
            this.$nextTick(() => {
              this.$refs.waterResourcesCarAccount.init(this.checkTableDataProps, 11);
            });
            // 判断是否是导入生成对账单
            this.importShow = false;
          });
      },
      // 刷新结算按钮
      async addResetBtn() {
        this.tableLoad = true;
        const res = await refreshSupplierResourcesCar();
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.$message.success(res.message);
        await this._supplierLinePageList();
      },
      // 查询
      searchBtn() {
        this.form.page = 1;
        this._supplierLinePageList();
      },
      // 重置
      resetBtn() {
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = '';
        }
        this.form.page = 1;
        this.form.rows = 10;
      },
      contractSizeChange(row) {
        this.form.rows = row;
        this._supplierLinePageList();
      },
      contractCurrentChange(page) {
        this.form.page = page;
        this._supplierLinePageList();
      },
      // 计划开始-结束日期验证
      dateChange(val) {
        if (this.form.planEndDate && this.form.planStartDate && (this.form.planEndDate <= this.form.planStartDate)) {
          if (val === this.form.planStartDate) this.form.planStartDate = '';
          if (val === this.form.planEndDate) this.form.planEndDate = '';
          this.$forceUpdate();
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },

      // 修改台账月 -- 打开弹窗
      // ledgerRevise() {
      //   if (!this.checkTableDataProps.length || this.checkTableDataProps.length == 0) return this.$message.error('请选择至少一条数据！');
      //   if (this.checkTableDataProps.length > 100) return this.$message.error('最多选择100条数据！');
      //   this.ledgerData = this.checkTableDataProps;
      //   this.ledgerVisible = true;
      // },
      // 修改台账月 -- 删除
      delLedger(index) {
        this.ledgerData.splice(index, 1);
      },
      // 修改台账月 -- 确认1`
      async ledgerChange() {
        const params = {
          standingBookMonth: this.ledger,
          childs: [],
        };
        this.ledgerData.forEach((res) => {
          params.childs.push({ id: res.id });
        });
        const {
          status,
          message,
        } = await updateStandingBookMonth(params);
        if (status !== 0) return this.$message.warning(message);
        this.$message.success(message);
        this.ledgerVisible = false;
        this.searchBtn();
      },
      // 修改台账月 -- 取消(关闭弹窗)
      ledgerClose() {
        this.ledger = '';
        this.ledgerData = [];
        this.ledgerVisible = false;
      },


      // 导入
      importClick(index, row) {
        if (this.checkList.length < 0) return this.$message.warning('至少选择三个条件');
        this.visible = false;
        this.importShow = true;
        this.addFlag = true;
      },
      // 多选事件触发
      handleCurrentChange(val) {
        this.checkTableDataProps = val;
        let Waybill = '';
        const array = val.filter((item, index) => {
          if (index === 0) Waybill = item.Waybill;
          return Waybill !== item.Waybill;
        });
        // 筛选  供应商相同数据
        this.checkTableDataProps = val.filter(item => Waybill === item.Waybill);
        array.forEach((value) => {
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          this.$message.warning('只能选择相同的供应商');
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => value.id === item.id), false);
        });
      },
      withChange(val) {
        this.name = val.name;
      },
      selectChange(val) {
        // 先清空选择
        this.$refs.multipleTable.clearSelection();
        // 将子组件表格数据赋值。
        this.checkTableDataProps = val;
        this.$nextTick(() => {
          val.forEach((row) => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find(item => row.id === item.id));
          });
        });
      },
      dialogClose() {
        this.$refs.waterResourcesCarAccount.activeName = 'information';
        this.name = 'information';
        this.addFlag = false;
      },
      selectable(row, index) {
        // 是否生成对账单 0：否 1：是  否 则不让勾选
        return row.isReconciliation !== 1;
      },
      download() {
        window.location.href = '/file/供应商导入模板(资源车).xlsx';
      },
      changeImportLoading(flag) {
        this.importLoading = flag;
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frame':
            this.form.frame = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },
    },
  };
</script>


<style lang='scss' scoped>
  .supplier-water {
    width: 100%;
    /*padding:20px 15px 0 25px;*/
    height: 100%;

    .exportButton {
      span {
        color: rgba(51, 136, 255, 1);
        margin-right: 10px;
        font-size: 14px;

        &:hover {
          cursor: pointer;
        }
      }
    }

    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after {
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      overflow: hidden;

      .flex1 {
        flex: 1;
      }

      .el-input {
        width: 150px;
      }

      .el-select {
        width: 150px;
      }

      .el-form-item {
        margin-bottom: 5px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
          line-height: 30px;
        }

        .el-form-item__content {
          line-height: 30px;
        }
      }
    }

    ::v-deep.content {
      .el-table th > .cell {
        font-weight: 700 !important;
      }

      .el-table .cell, .el-table td {
        padding: 0;
      }
    }

    ::v-deep .importBill {
      width: 100%;
      padding: 10px 0 20px 20px;

      .line {
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }

      .line + span {
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }

      .el-table td, .el-table th {
        padding: 0;
      }

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          /*padding:20px 23px 0 23px;*/
          padding-right: 20px;
          margin-top: 20px;
          font-size: 14px;

          .el-table .ui-warning-row {
            background-color: #fef0f0 !important;
          }

          .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover > td {
            background-color: #fef0f0 !important;
          }

          .el-table .ui-warning-row .cell {
            color: red;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }

          .iconError {
            font-size: 15px;

            i:hover {
              color: #00e1ff;
            }
          }


        }
      }

      .operation {
        display: flex;
        flex-direction: column;
        margin-top: 20px;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding-right: 20px;

          .el-button--mini {
            padding: 4px 4px;
          }
        }
      }
    }

    ::v-deep .add {


      font-weight: 700;
      width: 100%;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Input {
          display: flex;
          height: 30px;
          line-height: 30px
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;
          font-size: 14px;

          .el-table td, .el-table th {
            padding: 0;
          }

          .iconError {
            font-size: 20px;

            i:hover {
              color: #00e1ff;
            }
          }

          .yang {
            .el-form-item {

              margin-bottom: 15px;

              .el-form-item__label {
                /*width: 150px !important;*/
                /*color: #060606;*/
              }

              .el-input {
                width: 430px;
              }

              .el-textarea {
                width: 250px;

              }
            }

          }

        }
      }

      .btnContainer {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;

        button {
          margin: 0 15px;
        }
      }
    }

    ::v-deep {
      .el-table td {
        font-size: 13px;
      }

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

    .ledger {
      padding: 20px;

      .leader-input {
        display: inline-block;
        width: 100%;
        margin-bottom: 15px;

        span {
          display: inline-block;
          width: 100px;
        }

        ::v-deep {
          .el-input.el-input--small {
            display: inline-block;
            width: 200px;
          }
        }
      }

      ::v-deep {
        .el-table td {
          padding: 5px;
        }

        .el-table td, .el-table th {
          font-size: 13px;
          padding: 5px;
        }
      }
    }

  }

</style>
